import React from "react";
import "./Dropdownitem.scss";
const Dropdownitem = ({ text }) => {

  return (
    <div className="item"    >
      {typeof text !== "object" ? text : ""}
    </div>
  );
};

export default Dropdownitem;
